import { useStateMachine } from 'little-state-machine';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler, fileUploader } from '../../../../../_helpers/_methods';
import updateAction from './updateAction';
import { FormattedMessage } from 'react-intl';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';
import clearStore from './clearStore';
import { useSelector } from 'react-redux';
function IndividualStep4() {
  const { id, edit: isEdit } = useParams();

  const lang = useSelector((state) => state?.local?.local);
  const rosterData = useSelector((state) => state.rosters.rosters);

  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (e) => {
    setValue(e.target.id, e.target.value);
  };

  const { actions } = useStateMachine({ updateAction, clearStore });
  const { state } = useStateMachine({ updateAction });
  const navigate = useNavigate();
  const location = useLocation();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });
  const [fileID, setFileID] = useState();
  const [remarks, setRemarks] = useState('');
  const [resumeText, setResumeText] = useState('');

  const [defaultValue, setDefaultValue] = useState([]);
  useEffect(() => {
    if (isEdit) {
      if (rosterData) {
        if (Array.isArray(rosterData?.user?.resume)) {
          setDefaultValue(
            // eslint-disable-next-line no-undef
            rosterData.user.resume.map((item) => `${process.env.REACT_APP_BASE_URL}${item.url}`)
          );
        }
        setRemarks(rosterData?.remarks);
        setResumeText(rosterData.user?.resume_text);
        setValue('roster_remarks', rosterData?.remarks);
        setValue('CV_briefDetail', rosterData.user?.resume_text);
      }
    }
  }, [rosterData]);
  const onSubmit = async (data) => {
    actions.updateAction(data);
    const body = {
      fullname: state.fullname,
      username: state.email,
      email: state.email,
      password: 'password',
      gender: state.roster_gender?.value,
      phone: state.individual_roster_phone_num,
      pan: state.individual_roster_pan_number,
      ethenicity: state.roster_caste_group,
      expertises: state.experties,

      civil_service: state?.roster_civil_service_experience === 'yes' ? true : false,
      other_experience: state?.roster_other_experties?.toString() || '',

      qualifications: state.education.map((item) => ({
        id: isEdit ? item.educational_Level.id : '',
        level: `${item.educational_Level.value}`,
        final_year: `${item.qualified_year.value}`,
        sector: `${item.faculty.value}`,
        grade: `${item.secured_grade.value}`
      })),

      type: 'individual',

      province: state.rosters_address_physical_location_details?.province.value,
      district: state.rosters_address_physical_location_details?.district.value,
      municipality: state.rosters_address_physical_location_details?.local_level.value,
      ward: state.rosters_address_physical_location_details?.ward,
      tole: state.rosters_address_physical_location_details?.tole,
      remarks: typeof remarks === 'string' ? remarks : JSON.stringify(remarks),
      resume_text: typeof resumeText === 'string' ? resumeText : JSON.stringify(resumeText),

      is_public: data.roster_public_profile === 'yes' ? true : false,

      priorities: [
        {
          id: isEdit ? state.priority_first.id : '',
          province: state.priority_first?.value,
          level: 0
        },
        {
          id: isEdit ? state.priority_second.id : '',
          province: state.priority_second?.value,
          level: 1
        },
        {
          id: isEdit ? state.priority_third.id : '',
          province: state.priority_third?.value,
          level: 2
        },
        {
          id: isEdit ? state.priority_fourth.id : '',
          province: state.priority_fourth?.value,
          level: 3
        },
        {
          id: isEdit ? state.priority_fifth.id : '',
          province: state.priority_fifth?.value,
          level: 4
        },
        {
          id: isEdit ? state.priority_sixth.id : '',
          province: state.priority_sixth?.value,
          level: 5
        },
        {
          id: isEdit ? state.priority_seventh.id : '',
          province: state.priority_seventh?.value,
          level: 6
        }
      ]
    };
    if (body.phone === rosterData?.user?.phone) {
      delete body.phone;
    }
    // "___for document____": ""
    if (fileID) {
      body.resume = [fileID];
    }

    try {
      setIsLoading(true);
      isEdit
        ? await fetchWrapper.patch(`/profile/resource-person/${id}/`, body)
        : await fetchWrapper.post(`/profile/resource-person/`, body);

      actions.clearStore();

      setIsLoading(false);
      isEdit || location.pathname.split('/').includes('admin')
        ? navigate('/admin/rosters/individual_list')
        : navigate(`/instructions/roster/${state.email}`);
      toast.success(
        isEdit ? (
          <FormattedMessage id="resource_person_successful_update" />
        ) : (
          <FormattedMessage id="resource_person_successful_creation" />
        )
      );
    } catch (error) {
      setIsLoading(false);
      ErrorMessageHandler(error);
    }
  };

  const handleResumeUpload = async (e) => {
    try {
      let response = await fileUploader(e.target.files);
      setFileID(response.ids[0]);
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <h3 className="mt-4 d-flex">
          <FormattedMessage id="documents" />
          <p className="text-danger">
            &nbsp;(
            <FormattedMessage id="according_to_need" />)
          </p>
        </h3>
      </div>
      <div className="row">
        <div className="col-12 px-4">
          <FormGroup
            id="resource_file"
            label={<FormattedMessage id="your_resume" />}
            type="file"
            defaultValue={defaultValue}
            acceptedFormats={[
              'application/pdf',
              'application/msword',
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              'image/jpeg',
              'image/jpg',
              'image/png'
            ]}
            register={register}
            onChange={handleResumeUpload}
            error={errors}
            required={isEdit ? false : true}
            errorId="resume"
          />
        </div>
        <div className="col-12 px-4 mt-4">
          <FormGroup
            key={resumeText}
            type="editor"
            id="CV_briefDetail"
            label={<FormattedMessage id="your_bio_details" />}
            register={register}
            defaultValue={resumeText || 'Enter summary'}
            onChange={(e) => setResumeText(e)}
            error={errors}
          />
        </div>
        <div className="col-12 mt-4">
          <h3 className=" mt-3">
            <FormattedMessage id="remarks" />
          </h3>
          <div className="px-3">
            <FormGroup
              key={remarks}
              type="textarea"
              label={<FormattedMessage id="mention_remarks" />}
              id="roster_remarks"
              register={register}
              onChange={(e) => setRemarks(e)}
              defaultValue={remarks || 'Write your remarks'}
              error={errors}
            />
          </div>
        </div>
        <div className="col-12">
          <h3 className=" mt-3">
            <FormattedMessage id="public_profile" />
          </h3>
          <div className="px-3">
            <FormGroup
              id="roster_public_profile"
              type="radio"
              label={<FormattedMessage id="make_profile_public" />}
              options={[
                {
                  label: lang === 'ne' ? 'चाहन्छु' : 'Yes',
                  value: 'yes',
                  id: 'roster_public_profile_yes',
                  name: 'roster_public_profile'
                },
                {
                  label: lang === 'ne' ? 'चाहन्न' : 'No',
                  value: 'no',
                  id: 'roster_public_profile_no',
                  name: 'roster_public_profile'
                }
              ]}
              defaultValue={
                state?.roster_public_profile || (isEdit && (rosterData.is_public ? 'yes' : 'no'))
              }
              onChange={(e) => handleChange(e)}
              register={register}
              error={errors}
            />
          </div>
        </div>

        <div className="">
          <hr />
          <NavigationButtonGroup
            isSubmit={true}
            isLoading={isLoading}
            backTo={isEdit ? '/admin/rosters/individual_list' : ''}
          />
        </div>
      </div>
    </form>
  );
}

export default IndividualStep4;
